import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { getLocalTimeZone, today } from '@internationalized/date';
import { useMemo, useRef } from 'react';
import { useCalendarCell } from 'react-aria';
// Utility function to check if two dates are equal
const isSameDate = (date1, date2) => date1.day === date2.day && date1.month === date2.month && date1.year === date2.year;
const RangeCalendarCell = ({ state, date, dayIndex }) => {
    const calendarCellRef = useRef(null);
    const { cellProps, buttonProps, isSelected, isOutsideVisibleRange, isDisabled, formattedDate } = useCalendarCell({ date }, state, calendarCellRef);
    const { highlightedRange } = state;
    const todayDate = today(getLocalTimeZone());
    // Memoize calculations to avoid redundant recalculations on each render
    const isToday = useMemo(() => isSameDate(date, todayDate), [date, todayDate]);
    const isFirstDayInRange = useMemo(() => highlightedRange && isSameDate(date, highlightedRange.start), [date, highlightedRange]);
    const isLastDayInRange = useMemo(() => highlightedRange && isSameDate(date, highlightedRange.end), [date, highlightedRange]);
    const isWithinRange = useMemo(() => highlightedRange &&
        date.compare(highlightedRange.start) >= 0 &&
        date.compare(highlightedRange.end) <= 0, [date, highlightedRange]);
    const isStartOfWeek = dayIndex === 0;
    const isEndOfWeek = dayIndex === 6;
    // Simplify className logic by grouping similar conditions
    const cellClassNames = buildClassName('px-0.5 py-1', { 'px-0': isWithinRange });
    const contentClassNames = buildClassName('skyline-text-body-2 flex items-center justify-center', {
        'bg-light-blue text-black': isWithinRange,
        'rounded-l-3xl': isWithinRange && isStartOfWeek,
        'rounded-r-3xl': isWithinRange && isEndOfWeek,
        'bg-light-blue rounded-l-3xl text-white': isFirstDayInRange,
        'bg-light-blue  rounded-r-3xl text-white': isLastDayInRange,
    });
    const buttonClassNames = buildClassName('skyline-text-body-2 hover:bg-light-blue/10 flex h-6 w-6 items-center justify-center hover:rounded-full hover:text-black', {
        'border  border-solid border-primary-blue text-primary-blue rounded-full': isToday,
        'text-black/20 hover:bg-transparent': isDisabled,
        hidden: isOutsideVisibleRange,
        'bg-primary-blue rounded-full text-white': isSelected && (isFirstDayInRange || isLastDayInRange),
    });
    return (_jsx("td", { className: cellClassNames, ...cellProps, children: _jsx("div", { className: contentClassNames, children: _jsx("div", { ...buttonProps, className: buttonClassNames, ref: calendarCellRef, hidden: isOutsideVisibleRange, children: formattedDate }) }) }));
};
export default RangeCalendarCell;
//# sourceMappingURL=RangeCalendarCell.js.map